import React from 'react'
import { Col, Row } from 'reactstrap'

function Success({ data, cancel }) {

  return (
    <React.Fragment>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Success</h5>
      </div>

      <div className="modal-body">
        <Row>
          <Col className="d-flex justify-content-center"> <i className="fas fa-check-double font-size-28 text-success"></i>{" "}  </Col>
        </Row>
        <Row>
          <Col className="text-center text-success mt-3"> <span>{data.message}</span> </Col>
        </Row>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-success" onClick={cancel}>
          OK
        </button>
      </div>
    </React.Fragment>
  )
}

export default Success 